
export const flashDeals = [
  {
    id: 'flash-1',
    name: 'Professional Plan — Annual',
    description: 'Full access to unlimited quotes, team management for 15 users, real-time supplier pricing, and advanced reporting.',
    originalPrice: 468,
    salePrice: 187,
    discount: 60,
    period: 'year',
    badge: 'Best Seller',
    features: ['Unlimited quotes', 'Team management (15 users)', 'Real-time supplier pricing', 'Priority support', 'Custom branding'],
  },
  {
    id: 'flash-2',
    name: 'Enterprise Plan — Annual',
    description: 'Everything in Professional plus unlimited team members, dedicated account manager, and API access.',
    originalPrice: 948,
    salePrice: 474,
    discount: 50,
    period: 'year',
    badge: 'Top Value',
    features: ['Everything in Professional', 'Unlimited team members', 'Dedicated account manager', 'Custom integrations', 'API access'],
  },
  {
    id: 'flash-3',
    name: 'Professional Plan — 6 Months',
    description: 'Half-year commitment with full Professional features at a massive discount.',
    originalPrice: 294,
    salePrice: 117,
    discount: 60,
    period: '6 months',
    badge: 'Limited',
    features: ['Unlimited quotes', 'Team management (15 users)', 'Real-time supplier pricing', 'Priority support'],
  },
];

export const bundleDeals = [
  {
    id: 'bundle-1',
    name: 'Tradie Starter Bundle',
    description: 'Everything a solo tradie needs to go digital. Includes Professional Plan + AI Quote Assistant + Invoice Templates.',
    includes: ['Professional Plan (12 months)', 'AI Quote Assistant Add-on', '50 Premium Invoice Templates'],
    originalPrice: 708,
    salePrice: 349,
    savings: 359,
    icon: 'ri-hammer-line',
    tag: 'Most Popular',
  },
  {
    id: 'bundle-2',
    name: 'Team Growth Bundle',
    description: 'Scale your crew with confidence. Includes Enterprise Plan + GPS Tracking + Client Portal for your whole team.',
    includes: ['Enterprise Plan (12 months)', 'GPS Tracking Add-on', 'Client Portal Add-on', 'Priority Onboarding'],
    originalPrice: 1428,
    salePrice: 699,
    savings: 729,
    icon: 'ri-team-line',
    tag: 'Best Value',
  },
  {
    id: 'bundle-3',
    name: 'Full Business Suite',
    description: 'The complete MtaPlannerPro experience. Every feature, every add-on, unlimited everything.',
    includes: ['Enterprise Plan (12 months)', 'All Pro Add-ons Included', 'White-label Branding', 'Dedicated Success Manager', 'Custom API Integration'],
    originalPrice: 2388,
    salePrice: 999,
    savings: 1389,
    icon: 'ri-building-2-line',
    tag: 'Ultimate',
  },
];

export const seasonalPromos = [
  {
    id: 'seasonal-1',
    title: 'EOFY Tax-Time Special',
    description: 'Claim your software subscription as a tax deduction before June 30. Get 40% off any annual plan.',
    discount: 40,
    code: 'EOFY2025',
    validUntil: 'June 30, 2025',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    id: 'seasonal-2',
    title: 'Refer a Mate Deal',
    description: 'Refer another tradie and you both get 3 months free on any paid plan. No limits on referrals.',
    discount: 100,
    code: 'MATEDEAL',
    validUntil: 'Ongoing',
    icon: 'ri-user-add-line',
  },
  {
    id: 'seasonal-3',
    title: 'New Business Kickstart',
    description: 'Just registered your ABN? Get 6 months of Professional Plan completely free. Verification required.',
    discount: 100,
    code: 'NEWBIZ25',
    validUntil: 'December 31, 2025',
    icon: 'ri-rocket-2-line',
  },
  {
    id: 'seasonal-4',
    title: 'Multi-Trade Discount',
    description: 'Licensed in multiple trades? Get an extra 25% off any bundle when you verify 2+ trade licences.',
    discount: 25,
    code: 'MULTITRADE',
    validUntil: 'September 30, 2025',
    icon: 'ri-tools-line',
  },
];

export const testimonials = [
  {
    name: 'Jake Morrison',
    trade: 'Plumber, Sydney',
    quote: 'Grabbed the Team Growth Bundle during the flash sale — saved over $700. Best business decision this year.',
    avatar: 'JM',
  },
  {
    name: 'Sarah Chen',
    trade: 'Electrician, Melbourne',
    quote: 'The EOFY deal was a no-brainer. Claimed the full subscription as a tax deduction and saved 40%.',
    avatar: 'SC',
  },
  {
    name: 'Tom Bradley',
    trade: 'Carpenter, Brisbane',
    quote: 'Referred 4 mates and got a full year free. The referral program is incredibly generous.',
    avatar: 'TB',
  },
];
